import type { CenterProps } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';
import { MessageFileIcon, Tooltip } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

function FileUploader(props: CenterProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      content={t('chat.tooltipFile')}
      chakraPortal={false}
      openDelay={0}
      closeDelay={0}
      showArrow={true}
    >
      <Center
        h="1.85em"
        w="1.85em"
        cursor="pointer"
        borderRadius="sm"
        _hover={{ bg: 'bg.muted', color: 'brand.100' }}
        transition="all 0.2s"
        {...props}
      >
        <Center className="shake">
          <MessageFileIcon />
        </Center>
      </Center>
    </Tooltip>
  );
}

const MemoizedFileUploader = memo(FileUploader);

export { MemoizedFileUploader as FileUploader };
